module.exports = __webpack_public_path__ + "54d7248a2a10f1ceea6c099e2eb558bd.svg";